var icon = require('vue-svgicon')
icon.register({
  'ks-icon-clock': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M64 97.6A33.6 33.6 0 1 0 30.4 64 33.6 33.6 0 0 0 64 97.6M64 22a42 42 0 1 1-42 42 42 42 0 0 1 42-42m2.1 21v22L85 76.26l-3.15 5.17L59.8 68.2V43z"/>'
  }
})
